import { render, staticRenderFns } from "./my-question.vue?vue&type=template&id=22684058&scoped=true&"
import script from "./my-question.vue?vue&type=script&lang=js&"
export * from "./my-question.vue?vue&type=script&lang=js&"
import style0 from "./my-question.vue?vue&type=style&index=0&id=22684058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22684058",
  null
  
)

export default component.exports